import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DateObject } from 'react-multi-date-picker';

/**
 * اکامپوننت مربوط به رندر کردن قسمت مبوط به نمایش بازه زمانی انتخاب شده
 * @returns
 */
export function DisplaySelectedDateTime({
  openCalendar,
  value,
  fromTime,
  toTime,
}) {
  const from = value[0] ? new DateObject(value[0]).format('YYYY/MM/DD') : '';
  const to = value[1] ? new DateObject(value[1]).format('YYYY/MM/DD') : '';

  const { t } = useTranslation();
  const [size, setSize] = useState([0, 0]);
  useEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  fromTime = new DateObject(fromTime).format('HH:mm');
  toTime = new DateObject(toTime).format('HH:mm');
  return (
    <div className='custom-range-input' onClick={openCalendar}>
      {size[0] > 1300 ? (
        <bdi>
          {from && (
            <>
              <span>{t('common:from')}: </span>
              <span className='date'>{from}</span>
              <span className='time'>{fromTime}</span>
            </>
          )}
          {to && (
            <>
              <span>{t('common:to')}: </span>
              <span className='date'>{to}</span>
              <span className='time'>{toTime}</span>
            </>
          )}
        </bdi>
      ) : (
        <bdi>
          {to && (
            <>
              <span className='date ml-0 mr-0'>{to.slice(5)}</span>
            </>
          )}
          <span className='ml-5 mr-5'>-</span>
          {from && <span className='date ml-0 mr-0'>{from.slice(5)}</span>}
        </bdi>
      )}
    </div>
  );
}
DisplaySelectedDateTime.propTypes = {
  openCalendar: PropTypes.func,
  value: PropTypes.array,
  fromTime: PropTypes.any,
  toTime: PropTypes.any,
};
